/**
 * 数値に3桁カンマを付与する
 * @param number 数値
 */
export const getNumberWithCommas = (number: number): string => {
  return number.toLocaleString();
};
